module.exports = __webpack_public_path__ + "static/header-fb3098292b966a9c9d9635383d8d1a71.jpg";